namespace Nobox.CRM {
    export interface AccountingsForm {
        PlId: Serenity.ServiceLookupEditor;
        DealId: Serenity.ServiceLookupEditor;
        ReferenceNumber: Serenity.StringEditor;
        Date: CustomDatePickerEditor;
        FromName: Serenity.StringEditor;
        CtId: Serenity.StringEditor;
        Payment: PaymentsEditor;
        Desc: Serenity.TextAreaEditor;
        Currencies: CurrencyEditor;
        Amount: AutoNumericEditor;
        Attachment: Serenity.MultipleImageUploadEditor;
    }

    export class AccountingsForm extends Serenity.PrefixedContext {
        static formKey = 'Nobox.Accountings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountingsForm.init)  {
                AccountingsForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;
                var w2 = CustomDatePickerEditor;
                var w3 = PaymentsEditor;
                var w4 = s.TextAreaEditor;
                var w5 = CurrencyEditor;
                var w6 = AutoNumericEditor;
                var w7 = s.MultipleImageUploadEditor;

                Q.initFormType(AccountingsForm, [
                    'PlId', w0,
                    'DealId', w0,
                    'ReferenceNumber', w1,
                    'Date', w2,
                    'FromName', w1,
                    'CtId', w1,
                    'Payment', w3,
                    'Desc', w4,
                    'Currencies', w5,
                    'Amount', w6,
                    'Attachment', w7
                ]);
            }
        }
    }
}
